// core
import {Injectable} from '@angular/core';

// services
import {CustomHttp} from '../core/http-custom/http-custom.service';
import {AuthDetailsService} from '../auth/auth-details.service';
import {DomainService} from '../shared/services/domain.service';
import {TranslateService} from '@ngx-translate/core';

// constants


@Injectable()
export class RolesUtils {

  constructor(
    private _http: CustomHttp,
    private _authDetailsService: AuthDetailsService,
    private _domainService: DomainService,
    private _translateService: TranslateService
  ) {
  }


  /*
   * Filters out the roles that are not allowed to be set. There is a comparison between all possible roles that you can set and the roles that you would like to set (rolesList).
   * returns valid roles that can be set.
   */
  public filterRolesForSelection(rolesList: any, allPossibleRolesWithId: any) {
    let possibleRoleSelectionList: Array<any> = new Array<any>();
    for (let a = 0; a < rolesList.length; a++) {
      for (let b = 0; b < allPossibleRolesWithId.length; b++) {
        if ((rolesList[a].key || rolesList[a].roleKey) == allPossibleRolesWithId[b].key) {
          possibleRoleSelectionList.push(rolesList[a]);
        }
      }
    }
    return possibleRoleSelectionList;
  }

  /*
   * Creates a new list of roles without duplicates from two given ArrayLists (currentList and listToAdd)
   */
  public _mergeResultsWithoutDuplicates(currentList: any, listToAdd: any) {
    let allowToPush = true;
    for (let b = 0; b < listToAdd.length; b++) {
      for (let c = 0; c < currentList.length; c++) {
        if ((listToAdd[b].roleKey || listToAdd[b].key) == (currentList[c].roleKey || currentList[c].key)) {
          allowToPush = false;
        }
      }
      if (allowToPush == true) {
        currentList.push(listToAdd[b]);
      }
      allowToPush = true;
    }
    return currentList;
  }

  /*
  * Gets the prefix for the given role
  */
  public getPrefix(role: any) {
    let roleType = role.targetGroupRoleType;
    let prefix = "";
    switch (roleType) {
      case "Standard":
        prefix = "STD";
        break;

      case "Optional":
        prefix = "OPT";
        break;

      case "Intern":
        prefix = "INT";
        break;

      default:
        prefix = "";
    }
    return prefix;
  }

  public _prepareRolesSelection(data) {
    let list: Array<any> = [];
    let i = 0;

    if (data) {
      data.map((element) => {
        let prefix = this.getPrefix(element);
        return this._translateService.get(element.roleKey || element.key)
          .subscribe((translatedElement) => {
            list[i] = {
              value: element.id || element.roleId,
              label: prefix + " | " + translatedElement,
              prefix: prefix,
              translatedRole: translatedElement
            };
            i += 1;
          })
      });
    }
    list.sort((a, b) => b.prefix.localeCompare(a.prefix) || a.translatedRole.localeCompare(b.translatedRole));
    return list;
  }
}
